import { useEffect } from 'react';
import { type CustomerData, type Order, type Consultation } from '../../types';

interface Props {
  customerId: string;
  customer: CustomerData;
  financialSummary: { totalAmount: number; totalPaid: number; remainingAmount: number };
}

export default function OverviewTab({ customerId, customer, financialSummary }: Props) {
  // 개요 탭은 보통 상위에서 받은 데이터로 요약을 보여주지만,
  // 최근 발주/상담 내역 등을 따로 로딩하고 싶다면 여기서 fetch를 구현할 수 있습니다.
  // 현재는 부모가 넘겨준 financialSummary를 표시하는 역할에 집중합니다.
  
  return (
    <div className="space-y-8">
      <div>
        <h3 className="text-xl font-semibold text-gray-800 mb-6">금액 요약</h3>
        <div className="grid grid-cols-4 gap-6">
          <div className="bg-blue-50 rounded-lg p-6 text-center">
            <div className="text-2xl font-bold text-blue-600 mb-2">{financialSummary.totalAmount.toLocaleString()}원</div>
            <div className="text-sm text-blue-700">총계약금액</div>
          </div>
          <div className="bg-green-50 rounded-lg p-6 text-center">
            <div className="text-2xl font-bold text-green-600 mb-2">{financialSummary.totalPaid.toLocaleString()}원</div>
            <div className="text-sm text-green-700">입금완료</div>
          </div>
          <div className="bg-orange-50 rounded-lg p-6 text-center">
            <div className="text-2xl font-bold text-orange-600 mb-2">{financialSummary.remainingAmount.toLocaleString()}원</div>
            <div className="text-sm text-orange-700">잔여금액</div>
          </div>
        </div>
      </div>
      {/* ... 최근 활동 내역 등 추가 ... */}
    </div>
  );
}


// import { Order, Consultation, CustomerData } from '../../types';

// interface Props {
//   customer: CustomerData;
//   totalAmount: number;
//   totalPaid: number;
//   remainingAmount: number;
//   customerOrders: Order[];
//   consultations: Consultation[];
//   getOrderStatusColor: (status: string) => string;
// }

// export default function OverviewTab({
//   customer,
//   totalAmount,
//   totalPaid,
//   remainingAmount,
//   customerOrders,
//   consultations,
//   getOrderStatusColor
// }: Props) {
//   return (
//     <div className="space-y-8">
//       {/* 금액 요약 */}
//       <div>
//         <h3 className="text-xl font-semibold text-gray-800 mb-6">금액 요약</h3>
//         <div className="grid grid-cols-4 gap-6">
//           <div className="bg-blue-50 rounded-lg p-6 text-center">
//             <div className="text-2xl font-bold text-blue-600 mb-2">{totalAmount.toLocaleString()}원</div>
//             <div className="text-sm text-blue-700">총계약금액</div>
//           </div>
//           <div className="bg-green-50 rounded-lg p-6 text-center">
//             <div className="text-2xl font-bold text-green-600 mb-2">{totalPaid.toLocaleString()}원</div>
//             <div className="text-sm text-green-700">입금완료</div>
//           </div>
//           <div className="bg-orange-50 rounded-lg p-6 text-center">
//             <div className="text-2xl font-bold text-orange-600 mb-2">{remainingAmount.toLocaleString()}원</div>
//             <div className="text-sm text-orange-700">잔여금액</div>
//           </div>
//           {/* <div className="bg-purple-50 rounded-lg p-6 text-center">
//             <div className="text-2xl font-bold text-purple-600 mb-2">{(totalAmount * 0.1).toLocaleString()}원</div>
//             <div className="text-sm text-purple-700">부가세 (10%)</div>
//           </div> */}
//         </div>
//       </div>

//     </div>
//   );
// }